// Copyright 2018-2019 Unryo. All Rights Reserved.

/**
 * Delays an action until a provided reference is visible.
 *
 * Visibility is determined by the presence of an actual size (width).
 *
 * @param refs The global references holder.
 * @param id ID of the reference to check.
 * @param period Period at which to do the checks. Defaults to 100ms.
 */
export function delayUntilVisible (refs: {[s: string]: HTMLElement}, id: string, period = 100) {
  if (refs[id] && refs[id].clientWidth && refs[id].clientHeight) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    const checkLater = () => {
      setTimeout(() => {
        if (!refs[id]) {
          reject(new Error('component not available anymore'))
        } else if (refs[id].clientWidth && refs[id].clientHeight) {
          resolve()
        } else {
          checkLater()
        }
      }, period)
    }
    checkLater()
  })
}
